import { render, staticRenderFns } from "./OpenAndClose.vue?vue&type=template&id=76d40871"
import script from "./OpenAndClose.vue?vue&type=script&lang=js"
export * from "./OpenAndClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports